
export const NAME_REDUCER = 'notification';

export const PREFIX_ACTIONS = 'notification_feature_';


export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};
